var operatorsStatusApp;

(function() {
    if (!document.querySelector('#vue-operators-cnmc-redef-status') || GLOBAL_SECTION !== 'operators-cnmc-redef-status') {
        return;
    }

    operatorsStatusApp = new Vue({
        el: '#vue-operators-cnmc-redef-status',
        mixins: [MpScrollTo],

        data: {
            REQUEST_FAV_PATH: '/operators-cnmc-redef-status/favorite/id/',

            MAX_ADDRESS_LENGTH: 48,

            ACTION_INSERT: 'insert',
            ACTION_UPDATE: 'update',
            ACTION_ENABLED: 'enabled',
            ACTION_DISABLED: 'disabled',
            PAYLOAD_AVAILABLE_CNMC: 'available_cnmc',
            PAYLOAD_AVAILABLE_REDEF: 'available_redef',
            SOURCE_CNMC: 'cnmc',
            SOURCE_REDEF: 'redef',

            VIEW_OPERATORS: 'operators',
            VIEW_HISTORY: 'history',

            CHANGE_DATE_TPL: {
                'insert': [],
                'update': [],
                'enabled': {
                    'cnmc': [],
                    'redef': []
                },
                'disabled': {
                    'cnmc': [],
                    'redef': []
                }
            },

            viewMode: '',

            fieldLabels: {},

            searchTerm: '',
            cnmc: false,
            redef: false,
            favorite: false,

            cnmcUpdatedDate: null,
            redefUpdatedDate: null,

            operators: [],
            changeHistory: {},

            isInitialized: false,
        },

        filters: {
            // FIXME Refactor this filter into global filters
            formatAddress: function (value, maxLength, ending) {
                var words = value.split(' ');
                var result = words.reduce(function(address, w) {
                    w = w.toLowerCase();
                    return address + ' ' + w.charAt(0).toUpperCase() + w.slice(1);
                }, '');

                return (result.length <= maxLength) ? result : result.slice(0, maxLength) + ending;
            }
        },

        computed: {
            nFavs: function() {
                this.operators.reduce((prev, curr) => prev += (curr.isFavorite) ? 1 : 0, 0);
            },

            filteredOperators: function() {
                return this.operators.filter((o) => {
                    if (this.cnmc && !o.availableCnmc) {
                        return false;
                    }

                    if (this.redef && !o.availableRedef) {
                        return false;
                    }

                    if (this.favorite && !o.isFavorite) {
                        return false;
                    }

                    if (this.searchTerm && !this.matchSearch(o, this.searchTerm.toUpperCase())) {
                        return false;
                    }

                    return true;
                });
            }
        },

        methods:{

            getStatusStyle: function(status, isMobile) {
                if (isMobile) {
                    return (status) ? 'u-color-atlantis--560' : 'u-color-crimsom--560';
                }

                return (status) ? 'u-bg-atlantis--560' : 'u-bg-crimsom--560';
            },

            getOperatorStyle: function(operator) {
                return operator.isOpen ? 'operators-list__operator--openned' : '';
            },

            getActionSource: function(change) {
                const payloadKeys = Object.keys(change.payload);

                if (payloadKeys.includes(this.PAYLOAD_AVAILABLE_CNMC)) {
                    return this.SOURCE_CNMC;
                }

                if (payloadKeys.includes(this.PAYLOAD_AVAILABLE_REDEF)) {
                    return this.SOURCE_REDEF;
                }

                return false;
            },

            parseChange: function(change) {
                if (!Object.keys(this.CHANGE_DATE_TPL).includes(change.action)) {
                    console.error('Not supported change action: '+change.action);
                    return;
                }

                if (!this.changeHistory[change.date]) {
                    this.changeHistory[change.date] = clone(this.CHANGE_DATE_TPL);
                }

                if (![this.ACTION_ENABLED, this.ACTION_DISABLED].includes(change.action)) {
                    return this.changeHistory[change.date][change.action].push(change);
                }

                const source = this.getActionSource(change);

                return (source) ? this.changeHistory[change.date][change.action][source].push(change) : false;
            },

            addDomChange: function(domNode) {
                const change = {
                    action: domNode.dataset.action,
                    date: domNode.dataset.date,
                    operator: domNode.dataset.operator,
                    payload: JSON.parse(domNode.querySelector('.js-change-payload').innerText)
                };

                this.parseChange(change);
            },

            addDomOperator: function(domNode) {

                this.operators.push({
                    id: domNode.getAttribute('id').split('-')[1],
                    name: domNode.dataset.name,
                    nif: domNode.dataset.nif,
                    code: domNode.dataset.code,
                    vat: domNode.dataset.vat,
                    address: domNode.dataset.address,
                    phone: domNode.dataset.phone,
                    availableCnmc: domNode.dataset.availableCnmc === '1',
                    availableRedef: domNode.dataset.availableRedef === '1',
                    availableCnmcIcon: domNode.dataset.availableCnmcIcon,
                    availableRedefIcon: domNode.dataset.availableRedefIcon,
                    isFavorite: domNode.dataset.favorite === '1',
                    startAt: domNode.dataset.startAt,
                    endAt: domNode.dataset.endAt,
                    isOpen: false,
                });
            },

            matchSearch: function(o, searchTerm) {
                return JSON.stringify(o).toUpperCase().lastIndexOf(searchTerm) >= 0;
            },

            init: function() {
                this.isInitialized = true;
                this.viewMode = this.VIEW_OPERATORS;
                this.fieldLabels = JSON.parse(FIELD_LABELS); // FIELD_LABELS is injected from PHP controller
            },

            onSearch: function() {
                // TODO filter results by this.searchTerm
            },

            changeView: function(mode) {
                if (mode == this.viewMode) {
                    return;
                }

                this.viewMode = mode;
            },

            onFavUpdated(response, operator) {
                if (!response || response.status != 200) {
                    this.undoToggleFav(operator);
                    return;
                }

                operator.isFavorite = (response.data == '1');
            },

            undoToggleFav: function(operator) {
                operator.isFavorite = !operator.isFavorite;
            },

            toggleFav: function(operator) {
                // Optimistic programming :)
                operator.isFavorite = !operator.isFavorite;

                axios
                .get(this.REQUEST_FAV_PATH + operator.id, {})
                .then((response) => this.onFavUpdated(response, operator))
                .catch(function(error) {
                    this.undoToggleFav(operator);
                    console.error(error);
                });
            },

            toggleChangeItem: function(ev) {
                const item = ev.currentTarget;

                if (item.className.indexOf('--openned') >= 0) {
                    return item.classList.remove('timeline__item--openned');
                }

                item.classList.add('timeline__item--openned');
            },

            openChangesDetail: function(ev) {
                const detail = ev.currentTarget.querySelector('.timeline__item-changes');

                if (detail.className.indexOf('open') >= 0) {
                    detail.classList.remove('timeline__item-changes--open');
                } else {
                    detail.classList.add('timeline__item-changes--open');
                }
            },

            onOperatorClicked: function(operator) {
                if (!operator) {
                    return;
                }

                operator.isOpen = !operator.isOpen;

                return operator.isOpen;
            },
        },

        watch: {},

        mounted: function() {
            this.$refs.ssrOperatorList.querySelectorAll('.js-operator-item').forEach(this.addDomOperator);
            this.$refs.ssrOperatorChanges.querySelectorAll('.js-change').forEach(this.addDomChange);
            this.init();
        },

        updated: function() {}
    });

})();
